import { memo } from 'react';
import {
  Banknote,
  Home,
  TrendingUp,
  FileText,
  BarChart3,
  Heart,
  Car,
  Bitcoin,
  Shield,
  PiggyBank,
  Building2,
  Package,
  Scale,
  Receipt,
  CreditCard,
  Zap,
  Wallet,
  Briefcase,
  type LucideIcon
} from 'lucide-react';
import { AssetType } from '../types';

interface InventoryIconProps {
  assetType: AssetType;
  className?: string;
}

// Icon mapping for asset and liability types
const iconMap: Record<AssetType, LucideIcon> = {
  // Asset types
  bank_account: Banknote,
  real_estate: Home,
  shares: TrendingUp,
  srn_shares: FileText,
  hin_shares: BarChart3,
  nursing_home_bonds: Heart,
  nursing_home_bond: Heart,
  motor_vehicles: Car,
  vehicle: Car,
  cryptocurrency: Bitcoin,
  life_insurance: Shield,
  superannuation: PiggyBank,
  public_entities: Building2,
  managed_funds: TrendingUp,
  private_company: Briefcase,
  other: Package,
  // Liability types
  funeral_burial: Heart,
  legal_professional: Scale,
  mortgage: Home,
  vehicle_loan: Car,
  tax_liability: Receipt,
  credit_card: CreditCard,
  personal_loan: Banknote,
  utility_bill: Zap,
  estate_expense: Wallet,
  other_liability: FileText
};

/**
 * Pure function component for displaying inventory icons
 * Maps asset types to their corresponding Lucide icons
 */
export const InventoryIcon = memo(
  ({ assetType, className = 'h-5 w-5' }: InventoryIconProps) => {
    const Icon = iconMap[assetType] || Package;

    return <Icon className={className} />;
  }
);

InventoryIcon.displayName = 'InventoryIcon';
